import { useState, forwardRef } from 'react';
import { createGenericContext, createBemBlockBuilder } from '@ebsco-ui/utils';
import { jsx } from 'react/jsx-runtime';

var _createGenericContext = createGenericContext({
  errorMessage: "RearrangeableMultiSelect compound components cannot be rendered outside of the RearrangeableMultiSelect component"
}),
    useRearrangeableMultiSelectContext = _createGenericContext.useGenericContext;
    _createGenericContext.GenericContextConsumer;
    var RearrangeableMultiSelectContextProvider = _createGenericContext.GenericContextProvider;

var MultiSelectBox = function MultiSelectBox(_ref) {
  var children = _ref.children;

  var _useRearrangeableMult = useRearrangeableMultiSelectContext(),
      getBemBlocksWith = _useRearrangeableMult.getBemBlocksWith;

  return /*#__PURE__*/jsx("div", {
    className: getBemBlocksWith("__box"),
    "data-auto": "rearrangeable-multi-select-box",
    children: children
  });
};

var MultiSelectBoxButtons = function MultiSelectBoxButtons(_ref) {
  var children = _ref.children;

  var _useRearrangeableMult = useRearrangeableMultiSelectContext(),
      getBemBlocksWith = _useRearrangeableMult.getBemBlocksWith;

  return /*#__PURE__*/jsx("div", {
    className: getBemBlocksWith("__box-buttons"),
    "data-auto": "rearrangeable-multi-select-box-buttons",
    children: children
  });
};

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

var handleSort = function handleSort(itemA, itemB, sortKey) {
  if (itemA[sortKey].toLowerCase() < itemB[sortKey].toLowerCase()) {
    return -1;
  } else {
    return 1;
  }
};

var useMultiSelect = function useMultiSelect(lItems, rItems) {
  var sort = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var sortKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "column1";

  var _useState = useState(sort ? lItems.sort(function (itemA, itemB) {
    return handleSort(itemA, itemB, sortKey);
  }) : lItems),
      _useState2 = _slicedToArray(_useState, 2),
      leftItems = _useState2[0],
      setLeftitems = _useState2[1];

  var _useState3 = useState(sort ? rItems.sort(function (itemA, itemB) {
    return handleSort(itemA, itemB, sortKey);
  }) : rItems),
      _useState4 = _slicedToArray(_useState3, 2),
      rightItems = _useState4[0],
      setRightitems = _useState4[1];

  var handleSelect = function handleSelect(item) {
    if (item && !(item !== null && item !== void 0 && item.isDisabled)) {
      item.isSelected = !item.isSelected;
      setLeftitems(_toConsumableArray(leftItems));
      setRightitems(_toConsumableArray(rightItems));
    }
  };

  var moveSelectedRight = function moveSelectedRight() {
    var selectedLeftItems = leftItems.filter(function (item) {
      return item.isSelected;
    });
    var remainingLeftItems = leftItems.filter(function (item) {
      return !item.isSelected;
    });
    selectedLeftItems = selectedLeftItems.map(function (item) {
      item.isSelected = false;
      return item;
    });
    var newRightItems = sort ? [].concat(_toConsumableArray(rightItems), _toConsumableArray(selectedLeftItems)).sort(function (itemA, itemB) {
      return handleSort(itemA, itemB, sortKey);
    }) : [].concat(_toConsumableArray(rightItems), _toConsumableArray(selectedLeftItems));
    setRightitems(_toConsumableArray(newRightItems));
    setLeftitems(_toConsumableArray(remainingLeftItems));
  };

  var moveSelectedLeft = function moveSelectedLeft() {
    var selectedRightItems = rightItems.filter(function (item) {
      return item.isSelected;
    });
    var remainingRightItems = rightItems.filter(function (item) {
      return !item.isSelected;
    });
    selectedRightItems = selectedRightItems.map(function (item) {
      item.isSelected = false;
      return item;
    });
    var newLeftItems = sort ? [].concat(_toConsumableArray(leftItems), _toConsumableArray(selectedRightItems)).sort(function (itemA, itemB) {
      return handleSort(itemA, itemB, sortKey);
    }) : [].concat(_toConsumableArray(leftItems), _toConsumableArray(selectedRightItems));
    setLeftitems(_toConsumableArray(newLeftItems));
    setRightitems(_toConsumableArray(remainingRightItems));
  };

  var moveAllRight = function moveAllRight() {
    var activeLeftItems = leftItems.filter(function (item) {
      return !item.isDisabled;
    });
    var disabledLeftItems = leftItems.filter(function (item) {
      return item.isDisabled;
    });
    var newRightItems = sort ? [].concat(_toConsumableArray(rightItems), _toConsumableArray(activeLeftItems)).sort(function (itemA, itemB) {
      return handleSort(itemA, itemB, sortKey);
    }) : [].concat(_toConsumableArray(rightItems), _toConsumableArray(activeLeftItems));
    newRightItems = newRightItems.map(function (item) {
      item.isSelected = false;
      return item;
    });
    setRightitems(_toConsumableArray(newRightItems));
    setLeftitems(_toConsumableArray(disabledLeftItems));
  };

  var moveAllLeft = function moveAllLeft() {
    var activeRightItems = rightItems.filter(function (item) {
      return !item.isDisabled;
    });
    var disabledRightItems = rightItems.filter(function (item) {
      return item.isDisabled;
    });
    var newLeftItems = sort ? [].concat(_toConsumableArray(leftItems), _toConsumableArray(activeRightItems)).sort(function (itemA, itemB) {
      return handleSort(itemA, itemB, sortKey);
    }) : [].concat(_toConsumableArray(leftItems), _toConsumableArray(activeRightItems));
    newLeftItems = newLeftItems.map(function (item) {
      item.isSelected = false;
      return item;
    });
    setLeftitems(_toConsumableArray(newLeftItems));
    setRightitems(_toConsumableArray(disabledRightItems));
  };

  return {
    leftItems: leftItems,
    rightItems: rightItems,
    handleSelect: handleSelect,
    moveAllRight: moveAllRight,
    moveAllLeft: moveAllLeft,
    moveSelectedRight: moveSelectedRight,
    moveSelectedLeft: moveSelectedLeft
  };
};

var RearrangeableMultiSelect = forwardRef(function (_ref, ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      children = _ref.children;
  var getBemBlocksWith = createBemBlockBuilder(["eb-rearrangeable-multi-select", className]);
  var contextProviderValue = {
    getBemBlocksWith: getBemBlocksWith
  };
  return /*#__PURE__*/jsx(RearrangeableMultiSelectContextProvider, {
    value: contextProviderValue,
    children: /*#__PURE__*/jsx("div", {
      className: getBemBlocksWith(),
      "data-auto": "rearrangeable-multi-select",
      ref: ref,
      children: children
    })
  });
});
RearrangeableMultiSelect.MultiSelectBox = MultiSelectBox;
RearrangeableMultiSelect.MultiSelectBoxButtons = MultiSelectBoxButtons;
RearrangeableMultiSelect.useMultiSelect = useMultiSelect;

export { RearrangeableMultiSelect as default };
//# sourceMappingURL=rearrangeable-multi-select-esm.js.map
